import { Chip } from '@mui/material';
import { AlertSubscriptionStatus, AlertSubscriptionStatusLabel } from '../../types/alerts';

const subscriptionStatusColors: Record<string, { main: string; bg: string }> = {
  [AlertSubscriptionStatus.ACTION_NEEDED]: { main: '#ef4444', bg: '#fef2f2' },
  [AlertSubscriptionStatus.QUEUED]: { main: '#465fff', bg: '#ecf3ff' },
  [AlertSubscriptionStatus.CANCELLED]: { main: '#58C492', bg: '#EAFBF3' },
  [AlertSubscriptionStatus.AUTO_CANCELLED]: { main: '#58C492', bg: '#EAFBF3' },
  [AlertSubscriptionStatus.NOT_SUBSCRIPTION]: { main: '#64748b', bg: '#f1f5f9' },
  [AlertSubscriptionStatus.AUTO_NOT_SUBSCRIPTION]: { main: '#64748b', bg: '#f1f5f9' },
  [AlertSubscriptionStatus.NOT_FOUND]: { main: '#d97706', bg: '#fef3c7' },
};

interface SubscriptionStatusChipProps {
  status: string;
}

export default function SubscriptionStatusChip({ status }: SubscriptionStatusChipProps) {
  const colors = subscriptionStatusColors[status] || { main: '#6b7280', bg: '#f3f4f6' };
  const label = AlertSubscriptionStatusLabel[status] ?? status;
  return (
    <Chip
      label={label}
      sx={{
        backgroundColor: colors.bg,
        color: colors.main,
        fontWeight: 500,
        borderRadius: '10px',
      }}
    />
  );
}
